export default __webpack_public_path__ + "static/media/cuba.b6e7777b.png";